import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "video-card"
}
const _hoisted_2 = { class: "links-grid" }
const _hoisted_3 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = ["src", "alt", "onError"]
const _hoisted_6 = { class: "link-title" }
const _hoisted_7 = { class: "link-content" }
const _hoisted_8 = { class: "link-domain" }
const _hoisted_9 = {
  key: 0,
  class: "link-description"
}

import { computed, ref, watchEffect } from "vue";
import Card from "primevue/card";
import { fetchMetadata } from "@/composables/getLinkInfo";
import type { QwikUCard, LinkPreview } from '@/types';

type Props = {
  mysmartcard: QwikUCard;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'LinksPage',
  props: {
    mysmartcard: {}
  },
  setup(__props: any) {

const props = __props;

// State
const linkPreviews = ref<LinkPreview[]>([]);
const isLoading = ref(false);

// Computed
const hasLinks = computed(() =>
  linkPreviews.value && linkPreviews.value.length > 0
);

// Methods
const handleImageError = (event: Event, link: LinkPreview): void => {
  const target = event.target as HTMLImageElement;
  target.src = link.favicon;
  link.usesFavicon = true;
};

// Watch for changes in smart card content
watchEffect(async () => {
  if (!props.mysmartcard?.SmartContent) return;

  const linkContents = props.mysmartcard.SmartContent.filter(
    content => content.contentType === "linkContent"
  );

  if (linkContents.length > 0) {
    try {
      isLoading.value = true;
      linkPreviews.value = await fetchMetadata(linkContents);
    } catch (error) {
      console.error('Error fetching link previews:', error);
    } finally {
      isLoading.value = false;
    }
  }
});

return (_ctx: any,_cache: any) => {
  return (hasLinks.value || isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "heading" }, [
          _createElementVNode("h2", null, [
            _createElementVNode("span", { class: "yellow" }, "My"),
            _createTextVNode(),
            _createElementVNode("span", { class: "black" }, "Links")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[0] || (_cache[0] = [
                _createElementVNode("div", { class: "loading-spinner" }, null, -1)
              ]))]))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(linkPreviews.value, (link, index) => {
                return (_openBlock(), _createElementBlock("a", {
                  key: index,
                  href: link.url,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  class: "link-card-wrapper"
                }, [
                  _createVNode(_unref(Card), { class: "link-card" }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["link-header", { 'favicon-only': link.usesFavicon }])
                      }, [
                        _createElementVNode("img", {
                          src: link.image,
                          alt: link.title,
                          class: _normalizeClass(['link-image', { 'favicon': link.usesFavicon }]),
                          onError: ($event: any) => (handleImageError($event, link)),
                          loading: "lazy"
                        }, null, 42, _hoisted_5)
                      ], 2)
                    ]),
                    title: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, _toDisplayString(link.title), 1)
                    ]),
                    content: _withCtx(() => [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, _toDisplayString(link.domain), 1),
                        (link.description)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(link.description), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ], 8, _hoisted_4))
              }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})